import api from '@admin/api/service';

export default {
  getPropertySuggestions(url, search) {
    return api.get(`${url}?key=${search}`);
  },
};
